import styled from "styled-components";

import { formatDate } from 'utils/utils';
export default function Period({ endDate }) {
  return (
    <PeriodText><Prefix>인증기간</Prefix>{` | ~ ${formatDate(endDate, '.')}까지`}</PeriodText>
  )
}

const PeriodText = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  color: #7F7F7F;
  margin-bottom: calc(100vw * (17 / 375));
`;

const Prefix = styled.span`
font-style: normal;
font-weight: 500;
font-size: calc(100vw * (14 / 375));
line-height: calc(100vw * (17 / 375));
color: #4E4E4E;
`